import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls";
import Table, { buttonsStyle } from "../../../components/tables/table";
import { Button, Tooltip } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { getAllActiveDeals } from "../../../../api/deal";
import { registerLicense } from '@syncfusion/ej2-base';
import { getAllActiveProjects } from "../../../../api/project";

export default function DealAdvisorPage() {
    registerLicense("Ngo9BigBOggjHTQxAR8/V1JFaF5cX2JCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXZcc3RdQmFZVUByWkBWYEg=");


    const history = useHistory();
    const [refresh] = useState(false)
    const [data, setData] = useState([])


    useEffect(() => {

        Promise.all([getAllActiveProjects(), getAllActiveDeals()])
            .then(([projectsRes, dealsRes]) => {
                const advisorDeals = [];

                // Caso 1: Projects
                for (const project of projectsRes.data) {
                    project.advisors?.forEach(ad => {
                        advisorDeals.push({
                            project: project?.title,
                            seller: project.seller?.fullName || "---",
                            buyer: "---",
                            advisor: ad.advisor?.fullName || "---",
                            infoAdvisor: {
                                ...ad,
                                pathId: project?._id,
                                path: `advisor/${ad?.advisor?._id}/project`,
                                currentStep: ad?.currentStep ? ad?.currentStep?.charAt(0).toUpperCase() + ad?.currentStep?.slice(1) : ""
                            },
                            status: ad.status
                        });
                    });
                }

                // Caso 2: Deals
                for (const deal of dealsRes.data) {
                    deal.advisors?.forEach(ad => {
                        advisorDeals.push({
                            project: deal?.project?.title,
                            seller: "---",
                            buyer: deal?.buyer?.fullName || "---",
                            advisor: ad.advisor?.fullName || "---",
                            infoAdvisor: {
                                ...ad,
                                pathId: deal?._id,
                                path: `advisor/${ad?.advisor?._id}/deals`,
                                currentStep: ad?.currentStep ? ad?.currentStep?.charAt(0).toUpperCase() + ad?.currentStep?.slice(1) : ""
                            },
                            status: ad.status
                        });
                    });
                }

                setData(advisorDeals);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, [refresh]);

    console.log(data)

    function buttonFormatter(row) {
        return (
            <>
                <Tooltip title="Watch">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => {
                            localStorage.setItem("advisorDeal", JSON.stringify(row?.infoAdvisor))
                            history.push("/watch-advisorDeals/")
                        }}
                    >
                        <VisibilityIcon />
                    </Button>
                </Tooltip>
            </>
        );
    }

    const columns = [
        { dataField: "project", text: "Project name", sort: true },
        { dataField: "seller", text: "Seller name", sort: true },
        { dataField: "buyer", text: "Buyer name", sort: true },
        { dataField: "advisor", text: "Advisor name", sort: true },
        { dataField: "infoAdvisor.currentStep", text: "Current step", sort: true },
        {
            dataField: "infoAdvisor.status", text: "",
            formatter: (_cell, row) => {
                if (row.infoAdvisor.status !== "accepted") {
                    return null;
                }

                return buttonFormatter(row);
            },
            headerStyle: { width: '150px' }
        }
    ];

    return (
        <>
            <Card>
                <CardHeader title="Advisor Deals list">
                </CardHeader>
                <CardBody>
                    <Table data={data} columns={columns} key={data.length} />
                </CardBody>
            </Card>
        </>
    );
}